module.exports = __webpack_public_path__ + "static/profcast-kerst-e2f4f11bb1789c567f14a5d25df02485.jpeg";